namespace Serenity {
    @Decorators.registerInterface('Serenity.IValidateRequired')
    export class IValidateRequired {
    }

    export interface IValidateRequired {
        get_required(): boolean;

        set_required(value: boolean): void;
    }
}